import {customAlphabet} from 'nanoid/non-secure';
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const nanoid = customAlphabet(alphabet, 21);

const ITEMS_ID_SIZE = 5;

export const shortId = () => nanoid(ITEMS_ID_SIZE);
